import { memo, useMemo } from 'react';
import { Grid, Divider } from '@mui/material';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import { FormikErrors, FormikTouched } from 'formik';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import { ItalianVM } from 'shell/view-models/register-office-practice-vm';

interface FormProps {
  values?: ItalianVM;
  onChange: (key: keyof ItalianVM, value: ItalianVM[keyof ItalianVM]) => void;
  errors?: FormikErrors<ItalianVM>;
  touched?: FormikTouched<ItalianVM>;
  disabled?: boolean;
  ForPracticeTemporary?: boolean;
}

const AeDataComponent = ({
  values,
  onChange,
  errors,
  touched,
  disabled,
}: FormProps): React.ReactElement => {
  const isRequiredControlRevenueAgency = useMemo(() => {
    if (values?.houseOccupationType !== '2' && values?.houseOccupationType !== '4') {
      return false;
    }
    return true;
  }, [values?.houseOccupationType]);

  return (
    <Grid item xs={12} container spacing={2}>
      <>
        <Grid item xs={12}>
          <PmiTitleDivider>Controllo Agenzia Entrate</PmiTitleDivider>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12} md={6}>
          <PmiTextField
            id="officeContract"
            label={!isRequiredControlRevenueAgency ? 'Sede' : 'Sede *'}
            aria-label="Sede"
            fullWidth
            helperText={errors?.officeContract}
            error={touched?.officeContract && Boolean(errors?.officeContract)}
            value={values?.officeContract || ''}
            disabled={disabled}
            onChange={(event) => onChange('officeContract', event.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <PmiTextField
            id="numberContract"
            label={!isRequiredControlRevenueAgency ? 'Numero' : 'Numero *'}
            aria-label="Numero"
            fullWidth
            helperText={errors?.numberContract}
            disabled={disabled}
            error={touched?.numberContract && Boolean(errors?.numberContract)}
            value={values?.numberContract || ''}
            onChange={(event) => onChange('numberContract', event.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <DatePicker
            label={!isRequiredControlRevenueAgency ? 'Data' : 'Data *'}
            aria-label="Data"
            value={values?.dateContract || null}
            disabled={disabled}
            onChange={(value) => onChange('dateContract', value)}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="dateContract"
                helperText={errors?.dateContract}
                error={touched?.dateContract && Boolean(errors?.dateContract)}
                fullWidth
              />
            )}
          />
        </Grid>
      </>
    </Grid>
  );
};

AeDataComponent.displayName = 'A/E Data Component';

const AeData = memo(AeDataComponent);

export default AeData;
